import APIClient, { ErrorCode, ErrorMessage } from '@/api/APIClient'

export const Prize = {
  namespaced: true,
  state: {
    prizes: [],
    coupon: null,
    couponType: '0',
    gift_url: null
  },
  getters: {
    prizes: state => state.prizes // クーポンリスト
  },
  mutations: {
    UPDATE_PRIZES(state, payload) {
      state.prizes = payload
    }
    // UPDATE_COUPON_DETAIL (state, payload) {
    //   console.log(payload)
    //   state.coupon = payload.data
    //   state.couponType = payload.type
    // },
    // SET_GIFTEE (state, payload) {
    //   state.gift_url = payload.gift_url
    // }
  },
  actions: {
    /**
     * クーポンの取得
     *
     * @param {object} context
     * @param {object} context.commit
     * @param {object} payload
     */

    /**
     * 特定一覧の取得
     *
     * @param {*} param0
     * @param {*} payload
     */
    async actionFetchPrizes({ commit }, payload) {
      const token = payload.token
      const userId = payload.userId
      const accTime = payload.accTime
      let res = null
      if (token !== '') {
        res = await APIClient.getPrizeList(token, accTime, userId)
      } else {
        const error = {
          code: ErrorCode.CODE_ERROR_TOKEN,
          message: ErrorMessage.MSG_ERROR_TOKEN
        }
        throw error
      }
      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        console.log(res.data.data)
        commit('UPDATE_PRIZES', res.data.data['prizes'])
      } else {
        const error = {
          code: res.data.data.code,
          message: res.data.data.message
        }
        throw error
      }
    }
  }
}
